// Libraries
import styled from "styled-components"


export const VentureAboutProjectContainer = styled.div`

`

